import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Notification Count Store — Story 92.1 Task 4.
 *
 * Holds the authoritative server-side `unreadCount` for the current user.
 * Lives in `shared-domain` so future MFEs can read the count without going
 * through the Shell. AC #4 / Epic 91 §4: clients ASSIGN the value from each
 * SSE payload — never decrement locally — so the count converges to the
 * server's authoritative value regardless of `read-all` fan-out shape.
 */
interface NotificationCountStore {
  unreadCount: number;
  setUnreadCount: (n: number) => void;
}

export const useNotificationCountStore = create<NotificationCountStore>()(
  devtools(
    (set) => ({
      unreadCount: 0,
      setUnreadCount: (n) => {
        if (!Number.isFinite(n)) return;
        set({ unreadCount: Math.max(0, Math.floor(n)) }, false, 'notificationCount/set');
      },
    }),
    { name: 'notificationCountStore' }
  )
);
